!(function () {
  'use strict';
  document.addEventListener('DOMContentLoaded', function () {
    var e = document.querySelector('.dib'),
      t = document.querySelector('.dib-post-wrap'),
      r = document.createElement('div');
    if (
      (r.classList.add('blog-video-container'),
      (r.innerHTML =
        '<iframe width="1140" height="641.25" src="https://www.youtube.com/embed/wh32UGEJdn8" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>'),
      e.insertBefore(r, t),
      (o = document.querySelector('.dib-heading').querySelector('p')))
    ) {
      var n = o.innerText;
      o.classList.add('d-none');
      var o,
        d = document.createElement('div');
      d.classList.add('blog-description'),
        ((o = document.createElement('span')).innerText = n),
        d.append(o),
        e.insertBefore(d, t);
    }
  });
})();
